import { render, staticRenderFns } from "./LojaIntegrada.vue?vue&type=template&id=4641fc29"
import script from "./LojaIntegrada.vue?vue&type=script&lang=js"
export * from "./LojaIntegrada.vue?vue&type=script&lang=js"
import style0 from "./LojaIntegrada.vue?vue&type=style&index=0&id=4641fc29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports